var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside-brand d-flex flex-column align-items-center flex-column-auto py-3 py-lg-6 w-100"},[_c('router-link',{attrs:{"to":"/clients/view"}},[_c('img',{staticStyle:{"max-height":"23px !important"},attrs:{"src":_vm.siteLogo,"alt":"Logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }